import GameBoardPlayer from './game-board-player';

export default GameBoardPlayer;
